import React, {Component} from "react";
import JoditEditor from "jodit-react";
import 'jodit';
import 'jodit/build/jodit.min.css';
import Api, {NestorApi} from "../../config/api";
import imageCompression from "browser-image-compression";
import {buildUrlImagemDocumentoTemporario} from "../../config/config";
import localStorageService, {ACCESS_TOKEN_KEY} from "../../services/storage";
import Notification from "../Notification";

import svg from "../../assets/img/svg/camera-fotografica.svg"
import { Camera } from "../Camera/Camera";
import Dialog from "../Dialog/Dialog";
import { DialogContent } from "@material-ui/core";

class ModelEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: "",
      imagens: [],
      lastCursorPosition: null,
      notification: {
        isOpen: false,
        message: '',
        variant: ''
      },
      cameraShow:false
    };
  }

  async componentDidMount() {
    const {isDuplicar, id} = this.props;
    if (id && !isDuplicar) {
      
      const id = parseInt(this.props.id);
      setTimeout(async () => {
        const response = await Api.post("", {
          query: `
                query ($documentId: Long){
                          findByIdDocumentoModelo(id: $documentId){
                            nome
                            modelo
                            ativo
                            tipo
                            profissionaisSaude {
                              id
                              nome
                            }
                            documentoModeloImagens {
                              id
                            }
                          }
                }`,
          variables: { documentId: id }
        });

        const accessToken = await localStorageService.get(ACCESS_TOKEN_KEY);
        const { modelo, nome, ativo, profissionaisSaude, tipo, documentoModeloImagens } = response.data.data.findByIdDocumentoModelo;

        if(this.props.modeloDocumentoStore) {
          this.props.modeloDocumentoStore.profissionalSaudeSelected = profissionaisSaude || [];
          this.props.modeloDocumentoStore.existingImageIds = documentoModeloImagens?.map(img => img.id) || [];
        }
        this.setState({
          value: modelo.toString().replaceAll('{accessToken}',accessToken.toString())
        }, () => {
          this.updateCampos();
        });
        this.props.updateName(nome);
        this.props.updateStatus(ativo);
        this.props.updateTipoAssinatura && this.props.updateTipoAssinatura(tipo);
      }, 1000);
    }

    if (isDuplicar && this.props.textoHtml) {
      this.setState({
        value: this.props.textoHtml
      }, () => {
        this.updateCampos();
      });
    }
  }

  openNotification = (message, variant = null) => {
    this.setState({
      notification:{
        isOpen:  true,
        message: message,
        variant: variant
      }
    });

  }

  closeNotification = () => {
    this.setState({
      notification: {
        isOpen: false
      }
    })
  }

  resetNotification = () => {
    this.setState({
      notification: {
        isOpen: false,
        message: '',
        variant: ''
      }
    });
  }

  updateCampos = (value) => {
    if(!value){
      return;
    }
    const modelo = value.toString("html");
   
    const camposUsuario = modelo.match(/#{(.*?)}/g);
    if (camposUsuario) {
      this.props.updateCampos('entrada', camposUsuario);
    }
    const camposSistemaSujeito = modelo.match(/\${sujeitoAtencao.(.*?)}/g);
    if (camposSistemaSujeito) {
      this.props.updateCampos('sujeitoAtencao', camposSistemaSujeito);
    } else {
      this.props.updateCampos('sujeitoAtencao', []);
    }
    const camposSistemaProfissionalSaude = modelo.match(/\${profissionalSaude.(.*?)}/g);
    if (camposSistemaProfissionalSaude) {
      this.props.updateCampos('profissionalSaude', camposSistemaProfissionalSaude);
    } else {
      this.props.updateCampos('profissionalSaude', []);
    }
    const camposDoSistema = modelo.match(/\${sistema.(.*?)}/g);
    if (camposDoSistema) {
      this.props.updateCampos('sistema', camposDoSistema);
    } else {
      this.props.updateCampos('sistema', []);
    }
    const camposSistemaSujeitoInternacao = modelo.match(/\${sujeitoAtencaoInternacao.(.*?)}/g);
    if (camposSistemaSujeitoInternacao) {
      this.props.updateCampos('sujeitoAtencaoInternacao', camposSistemaSujeitoInternacao);
    } else {
      this.props.updateCampos('sujeitoAtencaoInternacao', []);
    }
  }

  onChange = value => {
  
    this.updateCampos(value);

    this.setState({value: value});
 
  };

  insertText = (el, tipo) => {
    this.jodit.selection.setCursorIn(this.state.lastCursorPosition);
    this.jodit.selection.insertHTML(`${el}&nbsp`);
  };

  handleImage = async (image) => {
    try {
      const accessToken = await localStorageService.get(ACCESS_TOKEN_KEY);

      const responseNestor = await this.uploadNestor(image);

      if(responseNestor.data) {
        return {
          id: responseNestor.data?.id,
          url: buildUrlImagemDocumentoTemporario(responseNestor.data?.id, accessToken),
        };
      }
      
      this.openNotification("Não foi possivel realizar o upload da imagem", 'error');

      return null;
    }catch(error){
      console.error('erro',error);
      this.openNotification("Não foi possivel realizar o upload da imagem", 'error');
    }
  }

  uploadNestor = async (image) => {
    const options = {
      maxSizeMB: 1,
      maxWidthOrHeight: 1920,
      useWebWorker: true
    };

    let blob;

    try {
      if (image instanceof Blob) {
        blob = image;
      } else {
        const response = await fetch(image);
        blob = await response.blob();
      }

      const file = new File([blob], "captura.jpg", { type: blob.type || "image/jpeg" });

      const compressedFile = await imageCompression(file, options);

      const formData = new FormData();
      formData.append('file', compressedFile);

      return NestorApi.post('/resource/AppHealth', formData);

    } catch (error) {
      console.error("Erro no uploadNestor:", error);
      throw error;
    }
  };

  setupInputListeners = () => {
    if (!this.jodit?.editor) return;

    const editorElement = this.jodit.editor;
    
    const handleInputChange = (e) => {
      const target = e.target;
      if (target.tagName === 'INPUT' && (target.type === 'checkbox' || target.type === 'radio')) {
        if (target.checked) {
          target.setAttribute('checked', 'checked');
        } else {
          target.removeAttribute('checked');
        }
      }
    };

    editorElement.addEventListener('click', handleInputChange, true);
    editorElement.addEventListener('change', handleInputChange, true);
  };

  syncInputAttributes = (htmlContent) => {
    if (!this.jodit?.editor) return htmlContent;

    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlContent, 'text/html');
    
    const editorInputs = this.jodit.editor.querySelectorAll('input[type="checkbox"], input[type="radio"]');
    const docInputs = doc.querySelectorAll('input[type="checkbox"], input[type="radio"]');

    docInputs.forEach((input, index) => {
      const editorChecked = editorInputs[index]?.checked;
      
      if (editorChecked) {
        input.setAttribute('checked', 'checked');
      } else {
        input.removeAttribute('checked');
      }
    });

    return doc.documentElement.outerHTML;
  };

  replaceInputsWithIcons = (htmlContent) => {
    if (!this.jodit?.editor) return htmlContent;

    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlContent, 'text/html');
    
    const editorInputs = this.jodit.editor.querySelectorAll('input[type="checkbox"], input[type="radio"]');
    const docInputs = doc.querySelectorAll('input[type="checkbox"], input[type="radio"]');
        
    docInputs.forEach((input, index) => {
      const editorInput = editorInputs[index];
      const isChecked = editorInput?.checked || false;
      const inputType = input.type;
            
      const icon = document.createElement('span');
      
      if (inputType === 'checkbox') {
        icon.textContent = isChecked ? '☑ ' : '☐ ';
      } else if (inputType === 'radio') {
        icon.textContent = isChecked ? '◉ ' : '○ ';
      }
      
      icon.style.fontSize = '16px';
      icon.style.marginRight = '5px';
      
      input.parentNode.insertBefore(icon, input);
      input.parentNode.removeChild(input);
    });
    
    return doc.documentElement.outerHTML;
  };

  handleSubmitFromChildForPrint = () => {
    const htmlContent = this.state.value.toString("html");
    const syncedHtml = this.syncInputAttributes(htmlContent);
    const finalHtml = this.replaceInputsWithIcons(syncedHtml);
    
    return finalHtml;
  };

  handleSubmitFromChild = () => {
    const htmlContent = this.state.value.toString("html");
    const syncedHtml = this.syncInputAttributes(htmlContent);
    return syncedHtml;
  };

  saveCursorPosition = () => {
      this.setState({lastCursorPosition: this.jodit.selection.current()});
  }

  handleSubmitImagesFromChild = () => {
    return this.state.imagens;
  };

  jodit;
  setRef = jodit => this.jodit = jodit;

  config = {
    sourceEditor: "area",
    readonly: this.props.disabled || false,
    showCharsCounter: false,
    showWordsCounter: false,
    showXPathInStatusbar: false,
    language: "pt_br",
    uploader: {
      insertImageAsBase64URI: true,
      defaultHandlerSuccess: e => {
        e.files.forEach(async (file) => {
          let image= await this.handleImage(file);
          if(image){
            this.jodit.selection.insertImage(image.url,null,300);
          }
        });
      }
    },
    autofocus: true,
    colorPickerDefaultTab: 'text',
    toolbarAdaptive: false,
    buttons: [
      "source",
      "bold",
      "italic",
      "underline",
      "strikethrough",
      "superscript",
      "subscript",
      "fontsize",
      "ul",
      "ol",
      "align",
      "brush",
      "image",
      "hr",
      "table",
      "|",
      "undo",
      "redo",
      "fullsize",],
      extraButtons:[
      {
        name: "camera",
        exec : ()=> this.setState({cameraShow: true}),
        iconURL: svg,
        tooltip: "Abrir câmera"
      },
    ],
    events: {
      afterInit: (instance) => {
        this.jodit = instance;
        this.setupInputListeners();
      },
      afterInsertImage: (image) => {
        const idImage = image.src.substring(image.src.length-36);
        this.setState({imagens: [...this.state.imagens, {id: idImage}]});
      }
    },
    disablePlugins: ["inline-popup"]
  }
  componentDidUpdate() {
    if(!this.props.loadingModelos){
      return
    }
    this.props.loadingModelos(!this.state.value);
  }

 handleTakePicture = async (blob) => {
  if (blob) {
    const image = await this.handleImage(blob); // só precisa do blob
    if (image) {
      this.jodit.selection.insertImage(image.url, null, 300);
      this.setState({ imagens: [...this.state.imagens, { id: image.id }] });
    }
    this.setState({ cameraShow: false });
  }
};

  render() {
    const { classes } = this.props;
    const { value ,cameraShow} = this.state;
   
    return (
      <div className={(classes.editor, classes.scrollEditor)}>
        <JoditEditor
          editorRef={this.setRef}
          value={value}P
          config={this.config}
          tabIndex={1}
          onChange={(newContent) => this.onChange(newContent)}
          onBlur={this.saveCursorPosition}
        />
        <Notification
          close={() => this.closeNotification()}
          reset={() => this.resetNotification()}
          isOpen={this.state.notification.isOpen}
          variant={this.state.notification.variant}
          message={this.state.notification.message}
        />
        {cameraShow && (
          <Dialog 
            onClose={() => this.setState({ cameraShow: false })}
            aria-labelledby="customized-dialog-title"
            open={cameraShow}
            classes={{
              paper: classes.paperCamera,
            }}>
            <DialogContent>
              <div>
                <Camera onCapture={blob => this.handleTakePicture(blob)} />
              </div>
            </DialogContent>
          </Dialog>
        )}
      </div>
    );
  }
}


export default ModelEditor;
